

/**
 * Creates a validate props on an object method.
 * @param {object} map Should be a prop to error message to throw if its missing
 * key/value map.
 * @returns {Function}
 */
function createValidatePropsMethod(map){
  /**
   * Checks that the user is a valid object and doesn't have invalid props.
   * Will throw if it does
   * @param {object} obj
   */
  return function validateProps(obj){
    if (!obj)
      throw new Error('Expected an object.')

    var keys = Object.keys(obj)

    Object.keys(map).forEach(prop => {
      var errorMessage = map[prop]
      removeKeyOrThrow(keys, prop, errorMessage)
    })

    if (keys.length > 0)
      throw new Error(`User object has invalid props '${keys.join(`', '`)}'.`)
  }
}

export default createValidatePropsMethod

/**
 * Removes a prop from an array of keys. If the prop can't be found in the
 * array will throw with the provided error message.
 * @param {Array<string>} keys
 * @param {string} prop
 * @param {string} errorMessage
 */
export function removeKeyOrThrow(keys, prop, errorMessage){
  var index = keys.indexOf(prop)
  if (index == -1)
    throw new Error(errorMessage)
  keys.splice(index, 1)
}


// WEBPACK FOOTER //
// ./src/store/lib/createValidatePropsMethod.js